// File: src/init.ts
import 'file-loader?name=[name].[ext]!./favicon.ico';
import 'file-loader?name=[name].[ext]!./.htaccess';
// REMOVED: import './manifest.json'; <--- This caused the error because the file moved to public/

// FIX: Polyfill console if it doesn't exist (IE/Old browsers safety)
if (!window.console) {
  (window as any).console = {
    log: () => {},
    warn: () => {},
    error: () => {},
    info: () => {}
  };
}

// FIX: Prevent "logToConsole" crash by ensuring no one can monkey-patch it incorrectly
try {
  if (typeof console.log === 'object') {
    // Some libraries try to assign properties to console.log
    // We ensure it remains a function to prevent TypeErrors
  }
} catch (e) {
  // Ignore
}

export const initApp = () => {
  console.log('Noviopus Client Initializing...');
};